import { styled } from "styled-components";

const LayoutDetails = styled.div`
  width: 100%;

  header {
    width: 100%;
    height: 70px;

    padding: 0px 20px;

    display: flex;
    justify-content: center;
    background-color: white;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    position: fixed;
    top: 0;
    left: 0;

    z-index: 999;

    @media (max-width: 700px) {
      justify-content: flex-start;

      align-items: center;
    }

    .content-header {
      width: 100%;
      max-width: 1200px;

      display: flex;
      justify-content: space-between;
      align-items: center;

      @media (max-width: 700px) {
        display: none;
      }

      .logo {
        img {
          width: 100px;
        }
      }

      nav {
        display: flex;
        gap: 50px;

        a {
          text-decoration: none;
          color: black;
        }
      }
    }

    .logo-mobile {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      height: 200px;
    }

    .content-mobile {
      display: none;
      gap: 20px;
      align-items: center;

      .hamburguer {
        font-size: 1.5rem;
      }

      @media (max-width: 700px) {
        display: flex;
      }

      .drawner {
        display: none;
        flex-direction: column;
        align-items: center;
        gap: 60px;

        padding: 20px 0px;

        position: absolute;
        left: 0;
        top: 0;

        width: 250px;
        height: 100vh;

        background-color: #fff;
        box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;

        .content-drawner {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 60px;

          position: relative;

          .close {
            position: absolute;
            right: 20px;
            top: 0px;
          }
        }

        .logo {
          img {
            width: 100px;
          }
        }

        nav {
          width: 60%;
          display: flex;
          flex-direction: column;
          gap: 50px;

          a {
            text-decoration: none;
            color: black;
          }
        }
      }

      .open {
        animation: open 0.3s ease;
        display: flex;
      }

      .close {
        animation: close 0.3s ease;
      }

      @keyframes open {
        0% {
          left: -250px;
          opacity: 0;
        }

        100% {
          left: 0;
          opacity: 1;
        }
      }

      @keyframes close {
        0% {
          left: 0;
          opacity: 1;
          display: flex;
        }

        100% {
          left: -250px;
          opacity: 0;
          display: none;
        }
      }
    }
  }

  .footer-top {
    width: 100%;
    padding: 50px;
    background-color: #df8925;

    display: flex;
    justify-content: center;
    align-items: center;

    color: "#fff";

    .content-footer-top {
      width: 100%;
      max-width: 1200px;
    }

    .logo-footer {
      color: #fff;
      font-weight: 600;
      letter-spacing: 2px;
    }
  }

  footer {
    width: 100%;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    border-top: 1px solid rgba(0, 0, 0, 0.1);

    .content {
      width: 100%;
      max-width: 1200px;

      display: flex;
      justify-content: space-between;

      a {
        text-decoration: none;
        color: #df8925;

        &:hover {
          opacity: 0.8;
        }
      }
    }

    @media (max-width: 700px) {
      .content {
        flex-direction: column;
        gap: 20px;
      }
    }
  }
`;

export default LayoutDetails;
